import { IFilterConfigItem } from '@/bundles/GroupFilters/interfaces/IFilterConfigItem';
import { FilterCategoryEnum, FilterTypeEnum } from '@/bundles/GroupFilters/enums/FilterTypeEnum';
import { memberJobFunctions } from '@/bundles/GroupFilters/consts';
import { getShowArchiveFilterConfig } from '@/bundles/GroupFilters/helpers/filtersConfig/getShowArchiveFilterConfig';

export const getMemberFilters = (): IFilterConfigItem[] => {
  return [
    // FilterCategoryEnum.press_release_details start
    {
      title: 'Job Function',
      name: 'member_job_function',
      type: FilterTypeEnum.autocomplete_multiple_select,
      items: memberJobFunctions,
      category: FilterCategoryEnum.member_details,
    },
    {
      title: 'Employee Type',
      name: 'member_employee_type',
      type: FilterTypeEnum.autocomplete_multiple_select,
      items: [
        { text: 'Contractor', value: 'contractor' },
        { text: 'Employee', value: 'employee' },
        { text: 'Temporary', value: 'temporary' },
      ],
      category: FilterCategoryEnum.member_details,
    },
    {
      title: 'Employee Category',
      name: 'member_employee_category',
      type: FilterTypeEnum.autocomplete_multiple_select,
      items: [
        { text: 'Full Time', value: 'Full Time' },
        { text: 'Part Time', value: 'Part Time' },
      ],
      category: FilterCategoryEnum.member_details,
    },
    {
      title: 'Include External Members',
      name: 'member_include_external',
      type: FilterTypeEnum.switch,
      category: FilterCategoryEnum.member_details,
    },
    {
      title: 'Role',
      name: 'member_role',
      type: FilterTypeEnum.member_role_autocomplete,
      category: FilterCategoryEnum.member_details,
    },
    // FilterCategoryEnum.press_release_details end
    // FilterCategoryEnum.created_edited start
    {
      title: 'Created/Edited by',
      name: 'member_view',
      type: FilterTypeEnum.create_updated_by_select, // should be handled in mappers to old filters
      category: FilterCategoryEnum.created_edited,
    },
    {
      title: 'Created by',
      name: 'member_created_by',
      type: FilterTypeEnum.create_updated_by_select, // should be handled in mappers to old filters
      category: FilterCategoryEnum.created_edited,
    },
    {
      title: 'Edited by',
      name: 'member_edited_by',
      type: FilterTypeEnum.create_updated_by_select, // should be handled in mappers to old filters
      category: FilterCategoryEnum.created_edited,
    },
    // FilterCategoryEnum.created_edited end
    getShowArchiveFilterConfig(),
  ].filter(Boolean) as IFilterConfigItem[];
};
